export default {
  "assetUploaded": "Asset uploaded",
  "uploadFailed": "Upload failed",
  "pleaseTryAgain": "Please try again.",
  "assetReset": "Asset reset",
  "resetFailed": "Reset failed",
  "settingsSaved": "Settings saved",
  "yourChangesHaveBeenApplied": "Your changes have been applied.",
  "failedToSaveSettings": "Failed to save settings",
  "pleaseCheckTheFormForErrors": "Please check the form for errors.",
  "loadingSettings": "Loading settings...",
  "generalSettings": "General Settings",
  "configureSystemWideSettingsForYourQuickBoxProInstance": "Configure system-wide settings for your QuickBox Pro instance.",
  "instanceSettings": "Instance Settings",
  "basicInformationAboutYourQuickBoxInstallation": "Basic information about your QuickBox installation",
  "instanceName": "Instance Name",
  "adminEmail": "Admin Email",
  "contactEmailForSystemNotifications": "Contact email for system notifications",
  "instanceDescription": "Instance Description",
  "quickBoxProDashboard": "QuickBox Pro Dashboard",
  "briefDescriptionShownInPageTitlesAndMetadata": "Brief description shown in page titles and metadata",
  "webRoot": "Web Root",
  "baseURLForYourDashboardLeaveEmptyForAuto": "Base URL for your dashboard (leave empty for auto-detection)",
  "timezoneLocale": "Timezone & Locale",
  "regionalAndTimeDisplayPreferences": "Regional and time display preferences",
  "systemTimezone": "System Timezone",
  "usedForDisplayingDatesAndTimesThroughoutTheDashboard": "Used for displaying dates and times throughout the dashboard",
  "dateFormat": "Date Format",
  "formatUsedForDisplayingDates": "Format used for displaying dates",
  "sessionsSecurity": "Sessions & Security",
  "sessionTimeoutAndCookieSettings": "Session timeout and cookie settings",
  "sessionSettingsHaveMovedTo": "Session settings have moved to",
  "sessionSettings": "Session Settings",
  "displayPreferences": "Display Preferences",
  "defaultThemeAndLandingPage": "Default theme and landing page",
  "userDefaultPage": "User Default Page",
  "pageShownAfterLoginForRegularUsers": "Page shown after login for regular users",
  "adminDefaultPage": "Admin Default Page",
  "pageShownAfterLoginForAdminUsers": "Page shown after login for admin users",
  "defaultTheme": "Default Theme",
  "themeForNewUsers": "Theme for new users",
  "additionalDashboardSettings": "Additional Dashboard Settings",
  "systemIntegrationsForDiskUsageNetworkingAndBandwidthStats": "System integrations for disk usage, networking, and bandwidth stats",
  "uploads": "Uploads",
  "fileUploadLimitsAndPermissions": "File upload limits and permissions",
  "avatarMaxSizeKB": "Avatar Max Size (KB)",
  "maximumAvatarUploadSizeInKilobytes25610240": "Maximum avatar upload size in kilobytes (256-10240)",
  "bannerMaxSizeKB": "Banner Max Size (KB)",
  "maximumBannerUploadSizeInKilobytes25610240": "Maximum banner upload size in kilobytes (256-10240)",
  "allowAvatarUploads": "Allow Avatar Uploads",
  "letUsersUploadCustomProfileAvatars": "Let users upload custom profile avatars",
  "branding": "Branding",
  "customizeLogosFaviconAndDefaultAvatarForYourInstance": "Customize logos, favicon, and default avatar for your instance",
  "authPages": "Auth Pages",
  "controlBrandingAndMessagingOnLoginAndRegistrationScreens": "Control branding and messaging on login and registration screens",
  "showLogoOnLoginRegisterPages": "Show logo on login/register pages",
  "displaysTheFullLogoIfUploadedOtherwiseTheLetter": "Displays the full logo if uploaded, otherwise the letter logo",
  "showLoginMessage": "Show login message",
  "showOrHideTheWelcomeMessageOnAuthPages": "Show or hide the welcome message on auth pages",
  "customLoginMessageMarkdownSupported": "Custom login message (Markdown supported)",
  "leaveEmptyToUseTheDefaultWelcomeMessage": "Leave empty to use the default welcome message.",
  "leaveEmptyToKeepTheDefaultWelcomeMessage": "Leave empty to keep the default welcome message.",
  "enableTheLoginMessageToggleToEditThisField": "Enable the login message toggle to edit this field.",
  "preview": "Preview",
  "featureFlags": "Feature Flags",
  "enableOrDisableSystemWideFeatures": "Enable or disable system-wide features",
  "maintenanceMode": "Maintenance Mode",
  "showMaintenancePageToNonAdminUsers": "Show maintenance page to non-admin users",
  "maintenanceMessage": "Maintenance Message",
  "weLlBeBackShortly": "We'll be back shortly.",
  "optionalMessageShownToNonAdminUsersDuringMaintenance": "Optional message shown to non-admin users during maintenance.",
  "userRegistration": "User Registration",
  "allowNewUsersToRegisterAccounts": "Allow new users to register accounts",
  "disableExternalNotificationChannels": "Disable External Notification Channels",
  "whenEnabledOnlyAdminsCanManageDiscordSignalAnd": "When enabled, only admins can manage Discord, Signal, and WhatsApp notification settings",
  "webConsole": "Web Console",
  "enableTheBrowserBasedTerminalForAdminUsers": "Enable the browser-based terminal for admin users",
  "interInstanceTransfer": "Inter-Instance Transfer",
  "moveDataBetweenYourOwnQuickBoxInstancesAdminTo": "Move data between your own QuickBox instances (admin-to-admin)",
  "deleteProtection": "Delete Protection",
  "guardTheServerAgainstFreezesCausedByLargeFile": "Guard the server against freezes caused by large file deletes on media and download apps",
  "wSDashboardStreamingMonitor": "WSDashboard (Streaming Monitor)",
  "enableTheRealTimeStreamingSessionMonitorForPlex": "Enable the real-time streaming session monitor for Plex, Emby, and Jellyfin",
  "playbackMirror": "Playback Mirror",
  "allowAdminsToMirrorActivePlaybackSessionsInRead": "Allow admins to mirror active playback sessions in read-only mode via the streaming dashboard",
  "mirrorSessionTTL": "Mirror Session TTL",
  "controlsHowLongAMirrorSessionStaysActiveBefore": "Controls how long a mirror session stays active before automatically expiring. When TTL is disabled, mirrors run indefinitely until the admin manually stops them or the source playback ends.",
  "disableTTL": "Disable TTL",
  "mirrorSessionsRunUntilManuallyStopped": "Mirror sessions run until manually stopped",
  "tTLSeconds": "TTL (seconds)",
  "durationBeforeAMirrorSessionAutoExpires10600": "Duration before a mirror session auto-expires (10–600)",
  "maskBannedIPAddresses": "Mask banned IP addresses",
  "whenEnabledHidesTheLastOctetOfBannedAttacker": "When enabled, hides the last octet of banned attacker IPs on the Fail2Ban dashboard. Off by default — admins normally need to see full offender addresses to identify repeat threats.",
  "autoProtectAppsOnInstall": "Auto-protect apps on install",
  "automaticallyEnableFail2banBruteForceProtectionForSupportedApps": "Automatically enable fail2ban brute-force protection for supported apps when they're installed. Off by default — you can also enable protection per-app on the Security → Fail2Ban tab.",
  "reset": "Reset",
  "saving": "Saving...",
  "saveChanges": "Save Changes",
  "sessionSettingsSaved": "Session settings saved",
  "sessionsInvalidated": "Sessions invalidated",
  "failedToInvalidateSessions": "Failed to invalidate sessions",
  "networkError": "Network error.",
  "loadingSessionSettings": "Loading session settings...",
  "configureSessionTimeoutsPersistenceAndConcurrencyPolicies": "Configure session timeouts, persistence, and concurrency policies.",
  "youHaveReadOnlyAccessToSessionSettings": "You have read-only access to session settings.",
  "timeouts": "Timeouts",
  "howLongBeforeInactiveSessionsExpire": "How long before inactive sessions expire",
  "userInactivityTimeout": "User Inactivity Timeout",
  "minutesOfInactivityBeforeAUserSessionExpires5": "Minutes of inactivity before a user session expires (5-1440)",
  "guestTimeout": "Guest Timeout",
  "minutesOfInactivityBeforeAGuestSessionExpires1": "Minutes of inactivity before a guest session expires (1-1440). Applies when guest access is enabled.",
  "persistenceCookies": "Persistence & Cookies",
  "sessionRememberMeAndExpiryBehavior": "Session remember-me and expiry behavior",
  "rememberMeDuration": "Remember Me Duration",
  "daysUntilRememberMeCookiesExpire1365": "Days until 'Remember me' cookies expire (1-365)",
  "autoExtendOnActivity": "Auto-Extend on Activity",
  "whenEnabledTheSessionTimerResetsOnEachRequest": "When enabled, the session timer resets on each request so active users stay logged in. When disabled, sessions expire at a fixed time after login regardless of activity.",
  "concurrency": "Concurrency",
  "controlSimultaneousSessionBehavior": "Control simultaneous session behavior",
  "allowMultipleSessions": "Allow Multiple Sessions",
  "whenDisabledLoggingInFromANewDeviceWill": "When disabled, logging in from a new device will revoke all other active sessions.",
  "sessionOperations": "Session Operations",
  "bulkSessionManagementActions": "Bulk session management actions",
  "invalidateAllNonAdminSessions": "Invalidate All Non-Admin Sessions",
  "thisWillForceAllNonAdminUsersToLog": "This will force all non-admin users to log in again. Admin sessions will not be affected.",
  "invalidating": "Invalidating...",
  "noActivationRequiredUsersCanLogInImmediatelyAfter": "No Activation Required — Users can log in immediately after registration",
  "emailActivationUsersReceiveAnActivationEmailAndMust": "Email Activation — Users receive an activation email and must verify before logging in",
  "adminActivationAnAdministratorMustManuallyApproveEachRegistration": "Admin Activation — An administrator must manually approve each registration",
  "registrationDisabledNewRegistrationsAreCompletelyBlocked": "Registration Disabled — New registrations are completely blocked",
  "registrationSettingsSaved": "Registration settings saved",
  "loadingRegistrationSettings": "Loading registration settings...",
  "registrationSettings": "Registration Settings",
  "configureAccountActivationQuotasAndUsernamePasswordPolicies": "Configure account activation, quotas, and username/password policies.",
  "youHaveReadOnlyAccessToRegistrationSettings": "You have read-only access to registration settings.",
  "activation": "Activation",
  "howNewAccountsAreActivatedAfterRegistration": "How new accounts are activated after registration",
  "accountActivationMode": "Account Activation Mode",
  "controlsHowNewUserAccountsAreActivatedAfterRegistration": "Controls how new user accounts are activated after registration.",
  "quotas": "Quotas",
  "defaultResourceLimitsForNewAccounts": "Default resource limits for new accounts",
  "unlimitedQuota": "Unlimited Quota",
  "whenEnabledNewUsersHaveNoDiskQuotaRestrictions": "When enabled, new users have no disk quota restrictions.",
  "defaultDiskQuota": "Default Disk Quota",
  "defaultDiskQuotaForNewUserAccounts": "Default disk quota for new user accounts.",
  "quotaUnit": "Quota unit",
  "defaultGroup": "Default Group",
  "assignNewUsersToAGroupOnRegistration": "Assign new users to a group on registration",
  "loadingGroups": "Loading groups...",
  "newUsersWillBeAddedToThisGroupAutomatically": "New users will be added to this group automatically.",
  "usernamePolicy": "Username Policy",
  "rulesForUsernameCreationAndValidation": "Rules for username creation and validation",
  "minimumLength": "Minimum Length",
  "minimumCharactersRequired232": "Minimum characters required (2-32)",
  "maximumLength": "Maximum Length",
  "maximumCharactersAllowed364": "Maximum characters allowed (3-64)",
  "forceLowercase": "Force Lowercase",
  "whenEnabledUsernamesAreAutomaticallyConvertedToLowercaseDuring": "When enabled, usernames are automatically converted to lowercase during registration.",
  "passwordPolicy": "Password Policy",
  "minimumAndMaximumPasswordLengthRequirements": "Minimum and maximum password length requirements",
  "minimumCharactersRequired4128": "Minimum characters required (4-128)",
  "maximumCharactersAllowed6256": "Maximum characters allowed (6-256)",
  "welcomeEmail": "Welcome Email",
  "emailNotificationForNewRegistrations": "Email notification for new registrations",
  "sendWelcomeEmail": "Send Welcome Email",
  "whenEnabledNewUsersReceiveAWelcomeEmailAfter": "When enabled, new users receive a welcome email after registration is complete.",
  "registration": "Registration",
  "placeholderPendingV4Migration": "Placeholder – pending v4 migration.",
  "comingSoon": "Coming soon",
  "thisAreaIsReservedForTheV4Migration": "This area is reserved for the v4 migration.",
  "contentAndToolingWillArriveAsTheCorrespondingV3": "Content and tooling will arrive as the corresponding v3 dashboard module is migrated.",
  "noPreview": "No preview",
  "uploading": "Uploading...",
  "replace": "Replace",
  "upload": "Upload",
  "dropToUpload": "Drop to upload",
  "orDragAndDrop": "or drag and drop",
  "custom": "Custom",
  "failedToLoadMountPoints": "Failed to load mount points",
  "diskSpace": "Disk Space",
  "usedToCalculateAvailableDiskSpaceOnTheDashboard": "Used to calculate available disk space on the dashboard.",
  "diskMountForDiskUsage": "Disk mount for disk usage",
  "failedToLoadNetworkInterfaces": "Failed to load network interfaces",
  "network": "Network",
  "selectThePrimaryNetworkInterfaceUsedForDashboardStatistics": "Select the primary network interface used for dashboard statistics.",
  "primaryNetworkInterface": "Primary network interface",
  "usedAcrossSystemDashboardsAndBandwidthStats": "Used across system dashboards and bandwidth stats.",
  "showAdvancedInterfaces": "Show advanced interfaces",
  "includeLoopbackBridgeAndVirtualInterfaces": "Include loopback, bridge, and virtual interfaces.",
  "redisIsReachable": "Redis is reachable.",
  "unableToConnectToRedis": "Unable to connect to Redis.",
  "redisIsNotConfigured": "Redis is not configured.",
  "running": "running",
  "stopped": "stopped",
  "redisConnected": "Redis connected",
  "redisConnectionFailed": "Redis connection failed",
  "redisNotConfigured": "Redis not configured",
  "unableToReadRedisStatus": "Unable to read Redis status",
  "redisUnreachable": "Redis unreachable",
  "provisionRedis": "Provision Redis",
  "provision": "Provision",
  "cancel": "Cancel",
  "typePROVISIONToConfirm": "Type PROVISION to confirm",
  "thisWillInstallRedisViaSystemPackagesAndStart": "This will install Redis via system packages and start the systemd service.",
  "configurationWillBeAppliedUsingTheValuesInThis": "Configuration will be applied using the values in this section.",
  "failedToSaveRedisSettings": "Failed to save Redis settings",
  "redisProvisioningFailed": "Redis provisioning failed",
  "unableToProvisionRedis": "Unable to provision Redis.",
  "provisioningFailed": "Provisioning failed",
  "redisProvisioned": "Redis provisioned",
  "redisIsInstalledAndRunning": "Redis is installed and running.",
  "unableToProvisionRedis2": "Unable to provision Redis",
  "healRedisConfiguration": "Heal Redis Configuration",
  "heal": "Heal",
  "thisWillAutomaticallyFixDetectedRedisConfigurationIssues": "This will automatically fix detected Redis configuration issues:",
  "theRedisServiceWillBeRestarted": "The Redis service will be restarted.",
  "redisHealingFailed": "Redis healing failed",
  "unableToFixRedisConfiguration": "Unable to fix Redis configuration.",
  "redisHealed": "Redis healed",
  "unableToHealRedis": "Unable to heal Redis",
  "issuesDetected": "Issues detected",
  "noIssuesFound": "No issues found",
  "redisConfigurationLooksHealthy": "Redis configuration looks healthy.",
  "redisNotInstalled": "Redis not installed",
  "useProvisionToInstallRedis": "Use Provision to install Redis.",
  "diagnosisFailed": "Diagnosis failed",
  "unableToDiagnoseRedisConfiguration": "Unable to diagnose Redis configuration.",
  "connected": "Connected",
  "failed": "Failed",
  "liveTelemetryRedis": "Live Telemetry (Redis)",
  "optionalRedisConnectionForLiveThroughputHistoryScrollZoom": "Optional Redis connection for live throughput history (scroll/zoom). URL overrides host/port.",
  "checkingRedis": "Checking Redis...",
  "configurationIssuesDetected": "Configuration Issues Detected",
  "theFollowingIssuesWereDetectedAndCanBeAutomatically": "The following issues were detected and can be automatically fixed:",
  "healing": "Healing...",
  "healRedis": "Heal Redis",
  "thisWillFixTheIssuesAndRestartRedis": "This will fix the issues and restart Redis",
  "redisURL": "Redis URL",
  "exampleRedisPasswordLocalhost63790": "Example: redis://:password@localhost:6379/0",
  "redisHost": "Redis host",
  "usedWhenURLIsEmpty": "Used when URL is empty.",
  "redisPort": "Redis port",
  "default6379": "Default 6379",
  "redisPassword": "Redis password",
  "optional": "Optional",
  "checking": "Checking...",
  "diagnose": "Diagnose",
  "provisioning": "Provisioning...",
  "provisionRedisSystemd": "Provision Redis (systemd)",
  "failedToLoadVnStatInfo": "Failed to load vnStat info",
  "unknown": "Unknown",
  "allInterfaces": "All interfaces",
  "resetVnStatBandwidthStatistics": "Reset vnStat bandwidth statistics",
  "resetStats": "Reset stats",
  "typeRESETToConfirm": "Type RESET to confirm",
  "thisWillPermanentlyClearVnStatStatisticsThisCannotBe": "This will permanently clear vnStat statistics. This cannot be undone.",
  "resetScope": "Reset scope",
  "databasePath": "Database path",
  "unableToResetStats": "Unable to reset stats",
  "bandwidthStatsReset": "Bandwidth stats reset",
  "allInterfacesWereReset": "All interfaces were reset.",
  "selectedInterfaceReset": "Selected interface reset.",
  "v3CLIIsNotAvailableOnThisSystem": "v3 CLI is not available on this system.",
  "reconcilerTimedOutTryAgainInAMoment": "Reconciler timed out. Try again in a moment.",
  "reconcilerFailedCheckServerLogsForDetails": "Reconciler failed. Check server logs for details.",
  "rebuildFailed": "Rebuild failed",
  "interfacesAlreadyInSync": "Interfaces already in sync",
  "vnstatTracksTheSameInterfacesPresentOnTheSystem": "vnstat tracks the same interfaces present on the system.",
  "interfacesRebuilt": "Interfaces rebuilt",
  "vnstatInterfaceSetReconciled": "vnstat interface set reconciled.",
  "unableToReachTheReconciler": "Unable to reach the reconciler.",
  "unavailable": "Unavailable",
  "notDetected": "Not detected",
  "bandwidthVnStat": "Bandwidth (vnStat)",
  "configureDashboardBandwidthBaselineAndManageVnStatStats": "Configure dashboard bandwidth baseline and manage vnStat stats.",
  "bandwidthStatsStartDate": "Bandwidth stats start date",
  "dashboardWillDisplayBandwidthStatsSinceThisDate": "Dashboard will display bandwidth stats since this date.",
  "selectedInterfaceOnly": "Selected interface only",
  "chooseHowMuchVnStatDataToReset": "Choose how much vnStat data to reset.",
  "vnStatDatabaseSize": "vnStat database size",
  "loading": "Loading...",
  "currentVnStatDatabaseSize": "Current vnStat database size.",
  "vnStatDatabasePath": "vnStat database path",
  "reconcileTheVnStatInterfaceSetAgainstTheLiveSystem": "Reconcile the vnStat interface set against the live system NICs. Auto-heal runs this on its own; use this to force a re-sync.",
  "autoHealIsActiveInTheBackgroundThisRuns": "Auto-heal is active in the background. This runs the same reconciler on demand — safe to re-run.",
  "reconciling": "Reconciling...",
  "rebuildInterfaces": "Rebuild interfaces",
  "resetting": "Resetting...",
  "resetBandwidthStats": "Reset bandwidth stats",
  "recommended": "Recommended",
  "lettersNumbersUnderscoresAndHyphensBestForMostSetups": "Letters, numbers, underscores, and hyphens. Best for most setups.",
  "usernamesMustStartWithALowercaseLetterAndMay": "Usernames must start with a lowercase letter and may contain lowercase letters, numbers, underscores, and hyphens. No spaces, dots, or uppercase letters.",
  "strictAlphanumeric": "Strict Alphanumeric",
  "lettersAndNumbersOnlyMaximumServiceCompatibility": "Letters and numbers only. Maximum service compatibility.",
  "usernamesMustStartWithALowercaseLetterAndContain": "Usernames must start with a lowercase letter and contain only lowercase letters and numbers. No special characters, spaces, or uppercase letters.",
  "withSeparators": "With Separators",
  "alsoAllowsDotsAlongsideUnderscoresAndHyphens": "Also allows dots alongside underscores and hyphens.",
  "usernamesMustStartWithALowercaseLetterAndMay2": "Usernames must start with a lowercase letter and may contain lowercase letters, numbers, underscores, hyphens, and dots. Some services may not handle dots correctly.",
  "standardLowercaseName": "Standard lowercase name",
  "commonSystemName": "Common system name",
  "lettersWithNumbers": "Letters with numbers",
  "endsWithANumber": "Ends with a number",
  "containsUnderscore": "Contains underscore",
  "startsWithANumber": "Starts with a number",
  "containsUppercase": "Contains uppercase",
  "specialCharacters": "Special characters",
  "singleCharacter": "Single character",
  "containsSpaces": "Contains spaces",
  "passes": "Passes",
  "fails": "Fails",
  "withoutForceLowercaseEnabledUsersMayRegisterWithMixed": "Without Force Lowercase enabled, users may register with mixed-case usernames. This can cause issues with Linux file paths and service configurations.",
  "thisPatternMayAllowUsernamesStartingWithANumber": "This pattern may allow usernames starting with a number. Linux usernames cannot begin with a digit — system provisioning will fail.",
  "thisPatternAllowsDotsInUsernamesSomeServicesAnd": "This pattern allows dots in usernames. Some services and reverse proxy configurations may not handle dots correctly.",
  "customPatternUseTheTesterBelowToVerifyBehavior": "Custom pattern — use the tester below to verify behavior.",
  "noPatternConfiguredSelectAPresetOrEnterA": "No pattern configured. Select a preset or enter a custom regex.",
  "usernameValidationPattern": "Username Validation Pattern",
  "chooseAPatternToControlWhichCharactersAreAllowed": "Choose a pattern to control which characters are allowed in usernames. Usernames are used as Linux system users, so service compatibility matters.",
  "usernameValidationPattern2": "Username validation pattern",
  "writeYourOwnRegexPatternForAdvancedControl": "Write your own regex pattern for advanced control.",
  "regexPattern": "Regex Pattern",
  "thisRegexPatternIsInvalidAndCannotBeCompiled": "This regex pattern is invalid and cannot be compiled.",
  "patternTester": "Pattern Tester",
  "pattern": "Pattern:",
  "invalidRegex": "Invalid regex",
  "none": "none",
  "typeAUsernameToTestU2026": "Type a username to test…",
  "testAUsernameAgainstThePattern": "Test a username against the pattern",
  "changingTheUsernamePatternDoesNotAffectExistingUser": "Changing the username pattern does not affect existing user accounts.",
  "generalViewForbidden": "You don't have permission to view settings.",
  "generalLoadFailed": "Failed to load settings",
  "generalUpdateFailed": "Failed to update settings",
  "sessionViewForbidden": "You don't have permission to view session settings.",
  "sessionLoadFailed": "Failed to load session settings",
  "sessionUpdateFailed": "Failed to update session settings",
  "registrationViewForbidden": "You don't have permission to view registration settings.",
  "registrationLoadFailed": "Failed to load registration settings",
  "registrationUpdateFailed": "Failed to update registration settings",
  "brandingViewForbidden": "You don't have permission to view branding settings.",
  "brandingLoadFailed": "Failed to load branding settings",
  "brandingUpdateFailed": "Failed to update branding settings",
  "assetUploadFailed": "Failed to upload asset",
  "assetResetFailed": "Failed to reset asset",
  "assetPromoteFailed": "Failed to set brand asset",
  "settings.validation.general.instanceName.max": "Instance name must be 100 characters or less",
  "settings.validation.general.instanceName.min": "Instance name is required",
  "settings.validation.general.instanceDescription.max": "Description must be 255 characters or less",
  "settings.validation.general.webRoot.max": "Web root must be 255 characters or less",
  "settings.validation.general.adminEmail.email": "Must be a valid email address",
  "settings.validation.general.timezone.max": "Timezone must be 64 characters or less",
  "settings.validation.general.timezone.min": "Timezone is required",
  "settings.validation.general.dateFormat.max": "Date format must be 50 characters or less",
  "settings.validation.general.dateFormat.min": "Date format is required",
  "settings.validation.general.locale.max": "Locale must be 10 characters or less",
  "settings.validation.general.locale.min": "Locale must be at least 2 characters",
  "settings.validation.general.sessionTimeout.range": "Session timeout must be between 5 and 1440 minutes",
  "settings.validation.general.sessionTimeout.regex": "Session timeout must be a positive number",
  "settings.validation.general.cookieExpiration.range": "Cookie expiration must be between 1 and 365 days",
  "settings.validation.general.cookieExpiration.regex": "Cookie expiration must be a positive number",
  "settings.validation.general.defaultPage.max": "Default page path must be 100 characters or less",
  "settings.validation.general.adminDefaultPage.max": "Admin default page path must be 100 characters or less",
  "settings.validation.general.avatarMaxSizeKb.range": "Avatar max size must be between 256 KB and 10240 KB",
  "settings.validation.general.avatarMaxSizeKb.regex": "Avatar max size must be a positive number",
  "settings.validation.general.bannerMaxSizeKb.range": "Banner max size must be between 256 KB and 10240 KB",
  "settings.validation.general.bannerMaxSizeKb.regex": "Banner max size must be a positive number",
  "settings.validation.general.maintenanceMessage.max": "Maintenance message must be 255 characters or less",
  "settings.validation.general.authMessageMarkdown.max": "Auth message must be 2000 characters or less",
  "settings.validation.general.dashboard.diskMount.max": "Disk mount must be 255 characters or less",
  "settings.validation.general.dashboard.diskMount.min": "Disk mount is required",
  "settings.validation.general.dashboard.networkInterface.max": "Network interface must be 64 characters or less",
  "settings.validation.general.bandwidth.startDate.regex": "Bandwidth start date must be a valid date",
  "settings.validation.general.telemetry.redisUrl.max": "Redis URL must be 512 characters or less",
  "settings.validation.general.telemetry.redisHost.max": "Redis host must be 255 characters or less",
  "settings.validation.general.telemetry.redisPort.range": "Redis port must be between 1 and 65535",
  "settings.validation.general.telemetry.redisPort.regex": "Redis port must be a number",
  "settings.validation.general.telemetry.redisPassword.max": "Redis password must be 255 characters or less",
  "settings.validation.general.audit.categories.max": "Audit categories must be 255 characters or less",
  "settings.validation.general.audit.retentionDays.range": "Audit retention must be between 1 and 365 days",
  "settings.validation.general.audit.retentionDays.regex": "Audit retention must be a positive number",
  "settings.validation.general.central.instanceId.max": "Instance ID must be 255 characters or less",
  "settings.validation.general.central.apiKey.max": "API key must be 512 characters or less",
  "settings.validation.general.media.storageRootTemplate.range": "Must be an absolute path with exactly one {user} placeholder, no '..', and no special characters",
  "settings.validation.general.media.storageRootTemplate.max": "Storage root template must be 255 characters or less",
  "settings.validation.general.vpn.config.stalenessPolicyDays.range": "Staleness policy must be between 1 and 3650 days",
  "settings.validation.general.vpn.config.stalenessPolicyDays.regex": "Staleness policy must be a positive number",
  "settings.validation.general.vpn.config.stalenessWarnLeadDays.range": "Warn-lead must be between 0 and 365 days",
  "settings.validation.general.vpn.config.stalenessWarnLeadDays.regex": "Warn-lead must be a positive number",
  "settings.validation.general.vpn.config.minHealthyPoolPerRegion.range": "Minimum healthy pool must be between 1 and 50",
  "settings.validation.general.vpn.config.minHealthyPoolPerRegion.regex": "Minimum healthy pool must be a positive number",
  "settings.validation.general.wsdashboard.mirror.ttlSeconds.range": "Mirror TTL must be between 10 and 600 seconds",
  "settings.validation.general.wsdashboard.mirror.ttlSeconds.regex": "TTL must be a whole number",
  "settings.validation.general.defaultTheme.choice": "Invalid theme selection",
  "settings.validation.session.userTimeout.range": "User timeout must be between 5 and 1440 minutes",
  "settings.validation.session.userTimeout.regex": "User timeout must be a positive number",
  "settings.validation.session.guestTimeout.range": "Guest timeout must be between 1 and 1440 minutes",
  "settings.validation.session.guestTimeout.regex": "Guest timeout must be a positive number",
  "settings.validation.session.cookieExpiration.range": "Cookie expiration must be between 1 and 365 days",
  "settings.validation.session.cookieExpiration.regex": "Cookie expiration must be a positive number",
  "settings.validation.registration.defaultQuota.regex": "Quota must be 0 (unlimited) or a number (1-9999) followed by MB, GB, or TB",
  "settings.validation.registration.defaultGroup.range": "Default group ID must be a positive integer",
  "settings.validation.registration.defaultGroup.regex": "Default group must be a numeric group ID",
  "settings.validation.registration.usernameMinChars.range": "Username min chars must be between 2 and 32",
  "settings.validation.registration.usernameMinChars.regex": "Username min chars must be a number",
  "settings.validation.registration.usernameMaxChars.range": "Username max chars must be between 3 and 64",
  "settings.validation.registration.usernameMaxChars.regex": "Username max chars must be a number",
  "settings.validation.registration.passwordMinChars.range": "Password min chars must be between 4 and 128",
  "settings.validation.registration.passwordMinChars.regex": "Password min chars must be a number",
  "settings.validation.registration.passwordMaxChars.range": "Password max chars must be between 6 and 256",
  "settings.validation.registration.passwordMaxChars.regex": "Password max chars must be a number",
  "settings.validation.registration.usernameRegex.range": "Must be a preset name (recommended, strict, permissive) or a valid regular expression",
  "settings.validation.registration.usernameRegex.max": "Regex pattern must be 255 characters or fewer",
  "settings.validation.registration.usernameMinChars.order": "Username min chars must not exceed username max chars",
  "settings.validation.registration.passwordMinChars.order": "Password min chars must not exceed password max chars",
  "settings.insufficientPermissions": "Insufficient permissions",
  "settings.general.fetchFailed": "Failed to fetch settings",
  "settings.general.updateFailed": "Failed to update settings",
  "settings.session.fetchFailed": "Failed to fetch session settings",
  "settings.session.updateFailed": "Failed to update session settings",
  "settings.registration.fetchFailed": "Failed to fetch registration settings",
  "settings.registration.updateFailed": "Failed to update registration settings",
  "settings.session.invalidateFailed": "Failed to invalidate sessions",
  "settings.branding.fetchFailed": "Failed to fetch branding settings",
  "settings.branding.invalidAssetType": "Invalid asset type",
  "settings.branding.multipartRequired": "Expected multipart/form-data",
  "settings.branding.noFile": "No file provided",
  "settings.branding.uploadFailed": "Failed to upload branding asset",
  "settings.branding.resetFailed": "Failed to reset branding asset",
  "settings.branding.assetIdRequired": "Body must include a valid assetId",
  "settings.branding.assetNotFound": "Asset not found",
  "settings.branding.assetFileMissing": "Asset file is missing on disk",
  "settings.branding.promoteFailed": "Failed to promote asset to branding",
  "settings.general.diskMountUnavailable": "Selected disk mount is not available.",
  "settings.general.networkInterfaceUnavailable": "Selected network interface is not available.",
  "settings.general.bandwidthDateInvalid": "Bandwidth start date must be a valid date.",
  "settings.general.bandwidthDateFuture": "Bandwidth start date cannot be in the future.",
  "settings.branding.maxSize": "File too large. Maximum size is {{maxMb}}MB.",
  "settings.branding.allowedTypes": "Unsupported file type. Allowed: {{allowed}}",
  "settings.branding.invalidSvg": "Invalid SVG file",
  "settings.branding.undetectableType": "Unable to detect file type",
  "settings.branding.unsupportedType": "Unsupported file type",
  "settings.branding.extensionMismatch": "File extension does not match content",
  "settings.registration.groupMissing": "Group with ID {{groupId}} does not exist",
  "settings.registration.adminGroupForbidden": "Cannot set Administrator group as the default registration group",
  "settings.branding.fileTooLarge": "File too large",
  "settings.branding.readUploadFailed": "Failed to read upload",
  "settings.validation.required": "Required",
  "settings.validation.invalidType": "Expected {{expected}}",
  "settings.validation.invalidChoice": "Invalid option. Expected one of: {{options}}",
  "settings.validation.invalidInput": "Invalid input",
  "settings.demoBlocked": "This action is not available in demo mode. Get QuickBox Pro for full access.",
  "generalSettingsTypesLabel1": "Disk Space",
  "generalSettingsTypesLabel2": "Network",
  "generalSettingsTypesLabel3": "Bandwidth (vnStat)",
  "generalSettingsTypesLabel4": "Live Telemetry (Redis)",
  "generalSettingsTypesLabel5": "Instance settings",
  "generalSettingsTypesLabel6": "Timezone & locale",
  "generalSettingsTypesLabel7": "Sessions & security",
  "generalSettingsTypesLabel8": "Display preferences",
  "generalSettingsTypesLabel9": "Additional dashboard settings",
  "generalSettingsTypesLabel10": "Uploads",
  "generalSettingsTypesLabel11": "Branding",
  "generalSettingsTypesLabel12": "Auth pages",
  "generalSettingsTypesLabel13": "Feature flags",
  "generalSettingsTypesLabel14": "2024-01-21 13:00:00 (ISO)",
  "generalSettingsTypesLabel15": "Sun, Jan 21, 2024, 1:00 pm",
  "generalSettingsTypesLabel16": "Jan 21, 2024, 1:00 pm",
  "generalSettingsTypesLabel17": "21/01/2024 13:00:00 (EU)",
  "generalSettingsTypesLabel18": "01/21/2024 1:00 pm (US)",
  "generalSettingsTypesLabel19": "Jan 21, 2024 (date only)",
  "generalSettingsTypesLabel20": "2024-01-21 (date only)",
  "generalSettingsTypesLabel21": "User Profile",
  "generalSettingsTypesLabel22": "Application Dashboard",
  "generalSettingsTypesLabel23": "Application Dashboard",
  "generalSettingsTypesLabel24": "System Dashboard",
  "generalSettingsTypesLabel25": "User Management",
  "generalSettingsTypesLabel26": "Streaming Dashboard",
  "generalSettingsTypesLabel27": "Spectre (Dark)",
  "generalSettingsTypesLabel28": "Reel (Warm)",
  "generalSettingsTypesLabel29": "Smoked (Dim)",
  "generalSettingsTypesLabel30": "Defaulted (Light)",
  "sessionSettingsTypesLabel1": "Timeouts",
  "sessionSettingsTypesLabel2": "Persistence & Cookies",
  "sessionSettingsTypesLabel3": "Concurrency",
  "sessionSettingsTypesLabel4": "Session Operations",
  "registrationSettingsTypesLabel1": "Activation",
  "registrationSettingsTypesLabel2": "Quotas",
  "registrationSettingsTypesLabel3": "Default Group",
  "registrationSettingsTypesLabel4": "Username Policy",
  "registrationSettingsTypesLabel5": "Password Policy",
  "registrationSettingsTypesLabel6": "Welcome Email",
  "timezonesLabel1": "Americas",
  "timezonesLabel2": "Eastern Time (New York)",
  "timezonesLabel3": "Central Time (Chicago)",
  "timezonesLabel4": "Mountain Time (Denver)",
  "timezonesLabel5": "Pacific Time (Los Angeles)",
  "timezonesLabel6": "Alaska (Anchorage)",
  "timezonesLabel7": "Hawaii (Honolulu)",
  "timezonesLabel8": "Toronto",
  "timezonesLabel9": "Vancouver",
  "timezonesLabel10": "Mexico City",
  "timezonesLabel11": "São Paulo",
  "timezonesLabel12": "Buenos Aires",
  "timezonesLabel13": "Lima",
  "timezonesLabel14": "Bogotá",
  "timezonesLabel15": "Europe",
  "timezonesLabel16": "London (GMT/BST)",
  "timezonesLabel17": "Dublin",
  "timezonesLabel18": "Paris",
  "timezonesLabel19": "Berlin",
  "timezonesLabel20": "Amsterdam",
  "timezonesLabel21": "Brussels",
  "timezonesLabel22": "Madrid",
  "timezonesLabel23": "Rome",
  "timezonesLabel24": "Zurich",
  "timezonesLabel25": "Vienna",
  "timezonesLabel26": "Stockholm",
  "timezonesLabel27": "Copenhagen",
  "timezonesLabel28": "Helsinki",
  "timezonesLabel29": "Warsaw",
  "timezonesLabel30": "Prague",
  "timezonesLabel31": "Athens",
  "timezonesLabel32": "Moscow",
  "timezonesLabel33": "Istanbul",
  "timezonesLabel34": "Asia & Middle East",
  "timezonesLabel35": "Dubai",
  "timezonesLabel36": "Jerusalem",
  "timezonesLabel37": "Tehran",
  "timezonesLabel38": "India (Kolkata)",
  "timezonesLabel39": "Dhaka",
  "timezonesLabel40": "Bangkok",
  "timezonesLabel41": "Singapore",
  "timezonesLabel42": "Hong Kong",
  "timezonesLabel43": "Shanghai",
  "timezonesLabel44": "Taipei",
  "timezonesLabel45": "Seoul",
  "timezonesLabel46": "Tokyo",
  "timezonesLabel47": "Manila",
  "timezonesLabel48": "Jakarta",
  "timezonesLabel49": "Africa",
  "timezonesLabel50": "Cairo",
  "timezonesLabel51": "Johannesburg",
  "timezonesLabel52": "Lagos",
  "timezonesLabel53": "Nairobi",
  "timezonesLabel54": "Casablanca",
  "timezonesLabel55": "Pacific & Oceania",
  "timezonesLabel56": "Sydney",
  "timezonesLabel57": "Melbourne",
  "timezonesLabel58": "Brisbane",
  "timezonesLabel59": "Perth",
  "timezonesLabel60": "Adelaide",
  "timezonesLabel61": "Auckland",
  "timezonesLabel62": "Fiji",
  "timezonesLabel63": "UTC Offsets",
  "timezonesLabel64": "UTC (Coordinated Universal Time)",
  "assetPreview": "{{asset}} preview",
  "assetUpdated": "{{asset}} has been updated.",
  "assetResetDefault": "{{asset}} has been reset to default.",
  "sessionSettingsMoved": "Session settings have moved to {{link}}.",
  "typeToConfirm": "Type {{word}} to confirm",
  "invalidateSessions": "Invalidate Sessions",
  "sessionsRevoked_one": "{{formattedCount}} non-admin session revoked.",
  "sessionsRevoked_other": "{{formattedCount}} non-admin sessions revoked.",
  "testsPassing": "{{passing}} of {{total}} passing",
  "loadingMounts": "Loading mount points...",
  "noMounts": "No mount points detected",
  "mountStats": "{{total}} total - {{used}} used - {{free}} free",
  "loadingInterfaces": "Loading interfaces...",
  "noInterfaces": "No interfaces detected",
  "noIp": "No IP",
  "interfaceLocal": "LOCALHOST",
  "interfaceUp": "UP",
  "interfaceDown": "DOWN",
  "interfaceUnknown": "UNKNOWN",
  "appRouting": "{{app}} routing -",
  "justNow": "just now",
  "interfaceScope": "Interface: {{name}}",
  "addedInterfaces": "Added: {{names}}",
  "removedInterfaces": "Removed: {{names}}",
  "lastModified": "Last modified: {{time}}",
  "redisServiceRunning": "Service: running.",
  "redisServiceStopped": "Service: stopped.",
  "errorCode": "Code: {{code}}",
  "networkErrorDetails": "Network error: {{message}}",
  "nonJsonResponse": "Server returned HTTP {{status}} (non-JSON). Check server/proxy logs.",
  "nonJsonStatus": "HTTP {{status}} — non-JSON response",
  "redisFixes_one": "Applied {{formattedCount}} fix. Redis service restarted.",
  "redisFixes_other": "Applied {{formattedCount}} fixes. Redis service restarted.",
  "redisIssues_one": "Found {{formattedCount}} fixable issue. See details above.",
  "redisIssues_other": "Found {{formattedCount}} fixable issues. See details above.",
  "lastChecked": "Last checked: {{time}} - {{status}}",
  "checkStatus": "Check status",
  "settings.unauthorized": "Unauthorized",
  "settings.databaseError": "Database error",
  "settings.vnstat.scopedInterfaceRequired": "Network interface is required for scoped reset",
  "settings.vnstat.interfaceUnavailable": "Selected network interface is not available",
  "settings.adminRequired": "Admin privileges required.",
  "settings.vnstat.noInterface": "No valid network interface could be resolved",
  "settings.authorizationFailed": "Authorization check failed",
  "settings.invalidBody": "Invalid request body",
  "settings.vnstat.invalidInterface": "Invalid network interface",
  "settings.vnstat.enumerateFailed": "Failed to enumerate network interfaces",
  "settings.vnstat.requestFailed": "Unexpected error processing vnstat request",
  "settings.vnstat.rebuildUnexpected": "Unexpected error during vnstat rebuild",
  "settings.redis.notConfigured": "Redis is not configured.",
  "settings.redis.diagnosisUnavailable": "Unable to diagnose Redis. The provisioning helper may not be installed.",
  "settings.redis.connected": "Connected",
  "settings.redis.connectedNonstandard": "Connected (non-standard response)",
  "settings.redis.connectFailed": "Unable to connect to Redis",
  "settings.redis.establishFailed": "Unable to establish connection",
  "settings.redis.connectionFailed": "Connection failed",
  "settings.vnstat.resetConfirmation": "Type RESET to confirm",
  "settings.vnstat.interfaceRequired": "Network interface is required",
  "settings.vnstat.cliMissing": "vnstat CLI not found on this system",
  "settings.vnstat.parseFailed": "Unable to parse vnstat output",
  "settings.vnstat.noInterfaces": "vnstat returned no interfaces",
  "settings.vnstat.noTraffic": "vnstat returned no traffic data",
  "settings.vnstat.interfaceNameRequired": "Interface name is required",
  "settings.vnstat.addTimeout": "vnstat --add timed out",
  "settings.vnstat.qbMissing": "v3 CLI not available; install QuickBox v3 to use this feature",
  "settings.vnstat.rebuildTimeout": "vnstat reconciler timed out after 30 seconds",
  "settings.vnstat.executionFailed": "vnstat execution failed",
  "settings.vnstat.addExit": "vnstat --add exited with code {{code}}",
  "settings.vnstat.rebuildExit": "qb manage vnstat --rebuild exited with code {{code}}",
  "settings.vnstat.resetExit": "vnstat exited with code {{code}}",
  "settings.redis.helperMissing": "Provisioning helper not found at {{path}}. Run the installer to set up Redis provisioning.",
  "settings.redis.privilegesRequired": "Redis provisioning requires elevated privileges. Ensure the sudoers helper is configured (see /etc/sudoers.d/v4-dashboard).",
  "settings.redis.notInstalled": "Redis is not installed.",
  "settings.redis.ensureUnreadable": "ensure-running completed but the result could not be read.",
  "settings.redis.provisioned": "Redis installed and started.",
  "settings.redis.healUnreadable": "Heal operation completed but the result could not be read. Check server logs for details.",
  "settings.redis.running": "Redis is running.",
  "settings.redis.stopped": "Redis is installed but not running.",
  "settings.redis.ensureFailed": "Redis ensure-running failed.",
  "settings.redis.provisionFailed": "Redis provisioning failed.",
  "settings.redis.healFailed": "Redis healing failed.",
  "settings.redis.issue.ipv6_unavailable": "IPv6 is unavailable",
  "settings.redis.fix.ipv6_unavailable": "Remove IPv6 (::1) from bind directive - system does not support IPv6",
  "settings.redis.issue.duplicate_bind": "Duplicate bind directives",
  "settings.redis.fix.duplicate_bind": "Remove duplicate 'bind' directives from redis.conf",
  "settings.redis.issue.duplicate_port": "Duplicate port directives",
  "settings.redis.fix.duplicate_port": "Remove duplicate 'port' directives from redis.conf",
  "settings.redis.issue.duplicate_daemonize": "Duplicate daemonize directives",
  "settings.redis.fix.duplicate_daemonize": "Remove duplicate 'daemonize' directives from redis.conf",
  "settings.redis.issue.daemonize_conflict": "daemonize conflicts with systemd",
  "settings.redis.fix.daemonize_conflict": "Change 'daemonize yes' to 'daemonize no' for systemd compatibility",
  "settings.redis.healed.ipv6_removed": "Removed IPv6 binding",
  "settings.redis.healed.deduplicated_bind": "Removed duplicate bind directives",
  "settings.redis.healed.deduplicated_port": "Removed duplicate port directives",
  "settings.redis.healed.deduplicated_daemonize": "Removed duplicate daemonize directives",
  "settings.redis.healed.daemonize_fixed": "Corrected daemonize configuration",
  "settings.redis.healed.service_unmasked": "Unmasked Redis service",
  "settings.redis.healed.service_enabled": "Enabled Redis service",
  "settings.redis.healed.service_restarted": "Restarted Redis service",
  "settings.redis.healed.service_started": "Started Redis service",
  "settings.redis.error.capability_check_failed": "Provisioning capability check failed",
  "settings.redis.error.ensure_command_failed": "Redis ensure-running command failed",
  "settings.redis.error.parse_error": "Unable to read Redis helper result",
  "settings.redis.error.heal_command_failed": "Redis heal command failed",
  "settings.redis.error.service_restart_failed": "Redis service restart failed",
  "settings.redis.error.not_installed": "Redis is not installed",
  "settings.redis.error.unmask_failed": "Failed to unmask Redis service",
  "settings.redis.error.enable_failed": "Failed to enable Redis service",
  "settings.redis.error.start_failed": "Failed to start Redis service",
  "settings.redis.healNotInstalled": "Redis is not installed",
  "settings.redis.healConfigMissing": "Redis config not found",
  "settings.redis.healingComplete": "Healing complete",
  "settings.redis.ensureComplete": "ensure-running complete",
  "settings.redis.ensureNotInstalled": "Redis is not installed",
  "settings.vnstat.queryTimeout": "vnstat timeout",
  "settings.vnstat.queryExit": "vnstat exited with code {{code}}",
  "settings.redis.unknownError": "Unknown error",
  "brandLabelcollapsedLogo": "Collapsed Logo",
  "brandLabelfullLogo": "Full Logo",
  "brandLabelfavicon": "Favicon",
  "brandLabeldefaultAvatar": "Default Avatar",
  "brandLabeldefaultBanner": "Default Profile Banner",
  "brandLabeldefaultBotAvatar": "QBxBot Avatar",
  "brandLabelemailLogoFull": "Email Logo (Full)",
  "brandLabelemailLogoIcon": "Email Logo (Icon)",
  "brandDescriptioncollapsedLogo": "Icon shown in the sidebar when collapsed (recommended: square, 64×64 or larger)",
  "brandDescriptionfullLogo": "Full logo shown in the sidebar (recommended: 200×50 or larger)",
  "brandDescriptionfavicon": "Browser tab icon (recommended: .ico or 32×32 PNG)",
  "brandDescriptiondefaultAvatar": "Fallback avatar for users without a custom profile picture",
  "brandDescriptiondefaultBanner": "Fallback profile banner when a user has not uploaded one",
  "brandDescriptiondefaultBotAvatar": "The avatar your install's QBxBot uses on chat platforms (square image, ≥512×512 recommended)",
  "brandDescriptionemailLogoFull": "Wide logo displayed in outgoing email headers (recommended: 200×50 or larger)",
  "brandDescriptionemailLogoIcon": "Square icon for compact email contexts (recommended: 64×64 or larger)"
} as const;
